<template>
  <div id="subject-view">
    <div class="select-document-type">
      <span style="align-items: center; justify-content: center; display:inline-flex;">
        <span class="mr-2"
          :class="{ isActive: !isCompany }"
          style="font-size: 16px !important; color: #BCC1D1;">{{i18n('Pessoa Física')}}</span>
        <v-switch class="justify-center"
          :label="i18n('Pessoa Jurídica')"
          v-model="isCompany"
          color="#27DABC" 
          data-testid="new-transaction-document-type-toggle" />
      </span>
    </div>
    <v-layout row wrap>
      <v-flex offset-xs2 xs8>
        <v-text-field
          :label="searchText"
          solo
          append-icon="search"
          class="search-input"
          v-model="search"
          :mask="maskSearchText"
          @input="searchSubject()"
          :data-testid="dataTestIdInput"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex offset-xs2 xs8>
        <v-layout row wrap>
          <v-flex xs12>
            <v-list dark>
              <v-list-tile @click="$emit('handle-event', {newSubject: true, isCompany: isCompany})" data-testid=new-transaction-new-client-button>
                <v-list-tile-content>
                  <v-list-tile-title>{{i18n('Novo Cliente')}}</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn icon ripple>
                    <v-icon color="grey lighten-1">navigate_next</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
              <v-list-tile v-if="subject" @click="$emit('handle-event', {selectedSubject: subject})">
                <v-list-tile-content>
                  <v-list-tile-title>{{subject.social_name}}</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn icon ripple>
                    <v-icon color="grey lighten-1">navigate_next</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <div class="buttons-container">
      <v-btn class="default-button" color="#BCC1D1" dark @click="$emit('handle-event', {back: true})">
        {{i18n('Voltar')}}
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubjectView',
  props: {
    subject: {
      type: Object
    },
    source_currency: {
      type: String
    },
    destination_currency: {
      type: String
    },
    operation: {
      type: String
    }
  },
  data() {
    return {
      search: '',
      isCompany: false,
      loadedSubjectStatus: 'not_loaded',
      loadedSubjectBankAccountStatus: 'not_loaded',
      subjectBankAccounts: [],
    }
  },
  computed: {
    isBRSubject() {
      return this.source_currency == "BRL" && this.operation == "receive" ||
        this.destination_currency == "BRL" && this.operation == "pay"      
    },
    isMXSubject() {
      return this.source_currency == "MXN" && this.operation == "receive" ||
        this.destination_currency == "MXN" && this.operation == "pay"
    },
    isCOSubject() {
      return this.source_currency == "COP" && this.operation == "receive" ||
        this.destination_currency == "COP" && this.operation == "pay"
    },
    isCLSubject() {
      return this.source_currency == "CLP" && this.operation == "receive" ||
        this.destination_currency == "CLP" && this.operation == "pay"
    },
    searchText() {
      return !this.isCompany && this.isBRSubject && this.i18n('Buscar por') + ' CPF'
      || this.isBRSubject && this.isCompany && this.i18n('Buscar por') + ' CNPJ'
      || this.isMXSubject && !this.isCompany && this.i18n('Buscar por') + ' CURP/RFC Persona Física'
      || this.isMXSubject && this.isCompany && this.i18n('Buscar por') + ' RFC Persona Moral'
      || this.isCOSubject && !this.isCompany && this.i18n('Buscar por') + ' CC/CE'
      || this.isCOSubject && this.isCompany && this.i18n('Buscar por') + ' NIT'
      || this.isCLSubject && this.i18n('Buscar por') + ' RUT'
      || this.i18n('Buscar')
    },
    maskSearchText() {
      return !this.isCompany && this.isBRSubject && '###.###.###-##'
      || this.isBRSubject && this.isCompany && '##.###.###/####-##'
      || this.isMXSubject && !this.isCompany && 'AAAA######NNNNNNNN'
      || this.isMXSubject && this.isCompany && 'AAA-######-NNN'
      || this.isCOSubject && '##########'
      || this.isCLSubject && '##.###.###-N'
    },
    dataTestIdInput() {
      return !this.isCompany && this.isBRSubject && 'new-transaction-cpf-input'
      || this.isBRSubject && this.isCompany && 'new-transaction-cnpj-input'
      || this.isMXSubject && !this.isCompany && 'new-transaction-curp-rfc-persona-fisica-input'
      || this.isMXSubject && this.isCompany && 'new-transaction-rfc-persona-moral-input'
      || this.isCOSubject && !this.isCompany && 'new-transaction-cc-input'
      || this.isCOSubject && this.isCompany && 'new-transaction-nit-input'
      || this.isCLSubject && 'new-transaction-rut-input'
      || 'new-transaction-input'
    },
    minimumDocLength() {
      return !this.isCompany && this.isBRSubject && 11
      || this.isBRSubject && this.isCompany && 14
      || this.isMXSubject && 12
      || this.isCOSubject && 6
      || this.isCLSubject && 9
      || 6
    }
  },
  methods: {
    i18n(str) {
      return this.$root.l(str)
    },
    searchSubject() {
      // logic to handle typing speed and avoid unnecessary requests
      if (this.search.length < this.minimumDocLength) {
        this.$emit('handle-event', {resetSubject: true})
        return
      }

      if (this.searchSubjectTimerId) clearTimeout(this.searchSubjectTimerId)

      this.searchSubjectTimerId = setTimeout(() => {
        this.doSearchSubject()
      }, 400)
    },
    doSearchSubject() {
      let successCallback = (response) => {
        if (response.body.data && response.body.data[0]) {
          this.$emit('handle-event', {setSubject: response.body.data[0]})
          this.loadedSubjectStatus = 'ok'
        }
        else {
          this.$emit('handle-event', {resetSubject: true})
          this.loadedSubjectStatus = 'not_found'
        }
      }

      let errorCallback = (response) => {
        if (response.status === 401) {
          this.loadedSubjectStatus = 'not_authorized'
        } else {
          this.loadedSubjectStatus = 'error'
        }
        console.log('errorCallback', response)
      }

      let token = this.$cookies.get('api_token')
      let params = { s: this.search, mode: 'document_number' }
      this.$http.get(this.$root.urls.customer__search, { params, headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
    }
  },
  mounted() {
    if (this.subject && this.subject.document_number) {
      this.search = this.subject.document_number
      this.searchSubject()
    }
  }
}
</script>

<style>
#subject-view .select-document-type {
  display: flex;
  justify-content: center;
}

.isActive,
#subject-view .v-input--is-label-active .v-label  {
  color: var(--primary-light-font-color) !important;
}
#subject-view .v-input--switch__track {
    color: var(--primary-button-background-color) !important;
}
#subject-view .v-input--switch__thumb {
    color: var(--secondary-button-background-color);
}
#subject-view .v-input--switch .accent--text {
    color: var(--secondary-button-background-color);
    caret-color: transparent;
}
#subject-view .v-input--switch .v-input--selection-controls__ripple {
    left: -14px;
    top: calc(50% - 24px);
    color: var(--secondary-button-background-color);
}
#subject-view .v-input--switch .v-input--selection-controls__input{
	width: 45px;
	margin-right: 10px;
  bottom: 10%;
}
#subject-view .v-input--switch__track{
	width: 40px;
	height: 26px;
	top: calc(50% - 13px);
	left: 0;
	right: 0;
	border-radius: 13px;
}
#subject-view .select-document-type label{
  color: #BCC1D1 !important;
}

#subject-view .search-input .v-input__icon--append i{
  color: #27DABC;
}

#subject-view h6 {
  font-size: 16px
}

#subject-view .v-list {
  background: #0C2E4A;
  border-radius: 4px 4px 0 0;
  padding: 0 0;
}
#subject-view .v-list__tile {
  background: #0C2E4A;
}
#subject-view .v-list__tile:not(.list-active):hover {
  background: rgb(14, 51, 82);
}
#subject-view .list-active {
  background: rgb(28, 75, 114);
}
#subject-view .v-list__group::before,
#subject-view .v-list__group::after {
  background: none;
}
#subject-view .v-list__group .v-list__group__items .v-list__tile {
  padding-left: 12px;
  background: #213F57;
}
#subject-view .v-list__group .v-list__group__items .v-list__tile:not(.list-active):hover {
  background: #264864;
}
#subject-view .v-list__group .v-list__group__items .v-list__tile.list-active {
  background: #38566E;
}

#subject-view .v-list__group .v-list__group__items .v-list__tile__title {
  color: #BCC1D1;
  text-transform: uppercase;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/NewTransaction/SubjectView.vue